import { BsQuestion, FiX, PiCheckCircleFill, TbCircleDashedCheck } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2';
import clsx from '@/lib/clsx';
import { credentialStatus } from '@shared/schema/credentialStatus.js';
import { formatDistanceToNowStrict } from 'date-fns';

const CredentialStatusIcon = ({ credential, className = '' }) => {
  const status = credential?.status || 'incomplete';
  const statusAsOf = credential?.statusAsOf;

  const statusSchema = credentialStatus[status];
  const formattedStatusAsOfMessage = statusAsOf ? `This connection is ${status} as of ${formatDistanceToNowStrict(new Date(statusAsOf), { addSuffix: true })}` : null;

  return (
    <div className={clsx('credential-status-icon', `status-${status}`, className)} style={{ backgroundColor: statusSchema?.color }} data-title={formattedStatusAsOfMessage || statusSchema?.description}>
      <IconV2 className={status}>
        {status === 'valid' && <PiCheckCircleFill />}
        {status === 'incomplete' && <TbCircleDashedCheck />}
        {['expired', 'revoked', 'invalid'].includes(status) && <FiX />}
        {['unknown', 'unsupported'].includes(status) && <BsQuestion />}
      </IconV2>
    </div>
  );
};

export default CredentialStatusIcon;
